import { atom, useAtom } from 'jotai';
import { useEffect } from 'react';
import { useMediaQuery } from 'usehooks-ts';

export const mobileCacheAtom = atom<boolean | null>(null);
export function useIsMobile() {
  const [isMobile, setIsMobile] = useAtom(mobileCacheAtom);

  useEffect(() => {
    const checkMobile = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 639);
    };

    checkMobile();

    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, [isMobile, setIsMobile]);

  const mediaQueryValue = useMediaQuery('(max-width: 639px)', {
    initializeWithValue: false,
  });

  // Using Tailwind's sm breakpoint (640px)
  return isMobile ?? mediaQueryValue;
}
